import React from 'react'
import ReactDOM from 'react-dom'
import { graphql } from 'react-apollo'
import PropTypes from 'prop-types'
import productUsesDefaultModel from '../common/helpers/productUsesDefaultModel'

import SmartRateDisplay from './SmartRateDisplay'
import Loader from '../common/Loader'
import AlertTriangle from '../common/icons/AlertTriangle'
import LoanPredictionsQuery from './queries/LoanPredictionsQuery'

export class SmartRates extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      error: PropTypes.object,
      latestPredictionsForLoans: PropTypes.arrayOf(PropTypes.object),
      loading: PropTypes.bool,
      loans: PropTypes.arrayOf(PropTypes.object)
    }),
    loanIds: PropTypes.arrayOf(PropTypes.number),
    parentComponent: PropTypes.oneOf(['loanStatusHeader', 'pipeline', 'loansList'])
  }
  unhideLoansTable = () => {
    document.getElementById('loans-table').style.display = 'table'
  }
  componentDidUpdate(prevProps) {
    if (prevProps.data.loading && !this.props.data.loading) {
      this.unhideLoansTable()
    }
  }
  componentDidCatch() {
    this.unhideLoansTable()
  }
  domNode = id => {
    return document.getElementById(`${id}-smart-rate-container`)
  }
  getTriangle = loanId => {
    return ReactDOM.createPortal(
      <AlertTriangle text="We're unable to load the data, please try again later by refreshing the page." color="orange" />,
      this.domNode(loanId)
    )
  }
  getSmartDisplay = (loanId, data) => {
    const { centerText } = this.props
    const { latestPredictionsForLoans, error, loans } = data
    const loan = (loans || []).find(({ rid }) => loanId === rid)
    if (!loan) {
      return this.getTriangle(loanId)
    }
    const { smartRate, needsRedecision, lastPredictionDataPermutation, businesses, rid } = loan
    const prediction = latestPredictionsForLoans.find(({ loanId }) => loanId === rid)
    const [oc] = businesses
    return ReactDOM.createPortal(
      <SmartRateDisplay
        color="orange"
        businessName={oc.name}
        dataPermutation={lastPredictionDataPermutation}
        defaultProbability={prediction ? prediction.riskRating : null}
        needsRedecision={needsRedecision}
        parentComponent="loansList"
        productUsesDefaultModel={productUsesDefaultModel(loan)}
        smartRate={smartRate}
        loanId={rid}
        error={error}
        centerText={centerText}
      />,
      this.domNode(rid)
    )
  }
  render() {
    const { loanIds, data } = this.props
    const { loading, error } = data
    if (loading) {
      return <Loader number={4} />
    }
    if (error) {
      return loanIds.map(loanId => (
        this.getTriangle(loanId)
      ))
    }
    return loanIds.map(loanId => (
      this.domNode(loanId) && this.getSmartDisplay(loanId, data)
    ))
  }
}

const SmartRatesQuery = graphql(LoanPredictionsQuery, {
  options: ({ loanIds }) => ({
    fetchPolicy: 'cache-and-network',
    variables: {
      loanIds
    }
  }),
  notifyOnNetworkStatusChange: true
})(SmartRates)

export default SmartRatesQuery
